var map = {
	"./aiSecurity/en.json": [
		3336,
		50
	],
	"./dataLeakage/en.json": [
		3337,
		53
	],
	"./ppd/en.json": [
		3338,
		56
	],
	"./ransomware/en.json": [
		3339,
		59
	],
	"./socialMedia/en.json": [
		3340,
		62
	],
	"./whatsApp/en.json": [
		3341,
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1126;
module.exports = webpackAsyncContext;